// extracted by mini-css-extract-plugin
export var article = "ManifestoItem-module--article--e7a30";
export var button = "ManifestoItem-module--button--80c18";
export var heading = "ManifestoItem-module--heading--0aad8";
export var index = "ManifestoItem-module--index--07b1a";
export var isActive = "ManifestoItem-module--isActive--fb1d9";
export var paragraph = "ManifestoItem-module--paragraph--04673";